import React, { memo } from 'react';
import { 
  Mic, 
  MicOff, 
  Video, 
  VideoOff, 
  Users, 
  Share, 
  MessageSquare,
  MoreHorizontal,
  PhoneOff,
  Settings,
  Grid3x3
} from 'lucide-react';

const MeetingContent = memo(({ activity }) => {
  const isUnmuted = activity?.action === 'unmute';
  const isSpeaking = activity?.action === 'speak';
  const isMuted = activity?.action === 'mute';
  const isReacting = activity?.action === 'react';

  const participants = [
    { name: 'Sarah Chen', avatar: '👩‍💼', speaking: isSpeaking, video: true },
    { name: 'Alex Rodriguez', avatar: '👨‍💻', speaking: false, video: true },
    { name: 'Maya Patel', avatar: '👩‍🔬', speaking: false, video: true },
    { name: 'Jordan Kim', avatar: '👨‍🎨', speaking: false, video: false },
    { name: 'You', avatar: '😊', speaking: false, video: true, isYou: true },
    { name: 'Chris Taylor', avatar: '👨‍💼', speaking: false, video: true }
  ];

  return (
    <div className="zoom-content">
      {/* Top Bar */}
      <div className="zoom-topbar">
        <div className="meeting-info">
          <span className="meeting-title">FluxSpaces Team Standup</span>
          <span className="meeting-time">10:23</span>
        </div>
        <div className="topbar-actions">
          <button className="zoom-icon-btn"><Settings size={10} /></button>
          <button className="zoom-icon-btn"><Grid3x3 size={10} /></button>
        </div>
      </div>

      {/* Video Grid */}
      <div className="zoom-grid">
        {participants.map((participant, i) => (
          <div 
            key={i} 
            className={`zoom-participant ${participant.speaking ? 'speaking' : ''} ${participant.isYou ? 'self' : ''}`}
          >
            {participant.video ? (
              <div className="participant-video">
                <div className="video-preview">
                  <div className="avatar-large">{participant.avatar}</div>
                </div>
              </div>
            ) : (
              <div className="participant-avatar">
                <div className="avatar-large">{participant.avatar}</div>
              </div>
            )}
            
            <div className="participant-info">
              <span className="participant-name">{participant.name}</span>
              {!participant.video && <VideoOff size={6} className="status-icon" />}
            </div>

            {participant.speaking && (
              <div className="speaking-indicator"></div>
            )}

            {isReacting && participant.isYou && (
              <div className="reaction-emoji">👍</div>
            )}
          </div>
        ))}
      </div>

      {/* Control Bar */}
      <div className="zoom-controls">
        <div className="controls-left">
          <button className={`control-btn ${isUnmuted || isSpeaking ? 'active' : ''}`}>
            {isUnmuted || isSpeaking ? <Mic size={12} /> : <MicOff size={12} />}
            <span>{isUnmuted || isSpeaking ? 'Mute' : 'Unmute'}</span>
          </button>
          <button className="control-btn">
            <Video size={12} />
            <span>Stop Video</span>
          </button>
        </div>

        <div className="controls-center">
          <button className="control-btn">
            <Users size={12} />
            <span>Participants</span>
          </button>
          <button className="control-btn">
            <MessageSquare size={12} />
            <span>Chat</span>
          </button>
          <button className="control-btn">
            <Share size={12} />
            <span>Share</span>
          </button>
          <button className="control-btn">
            <MoreHorizontal size={12} />
          </button>
        </div>

        <div className="controls-right">
          <button className="control-btn end-call">
            <PhoneOff size={12} />
            <span>End</span>
          </button>
        </div>
      </div>
    </div>
  );
});

MeetingContent.displayName = 'MeetingContent';

export default MeetingContent;
